var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ElementRef, ChangeDetectorRef } from '@angular/core';
import 'rxjs/add/operator/debounceTime';
import { loadSchemaModule, isSchemaButtonGroup } from './forms/schemas';
import { FormComponent } from './form.component';
var AppComponent = (function () {
    function AppComponent(elementRef, changeDetector) {
        var _this = this;
        this.elementRef = elementRef;
        this.changeDetector = changeDetector;
        this.model = {
            id: null,
            parent_id: null,
            location: null,
            date_time: (new Date()).toISOString().split('T')[0],
            incomplete: false,
            draft: false,
            user_id: null,
        };
        this._toast = { content: '' };
        this.reloadSchema();
        this.formActions = [
            {
                id: 'save',
                label: 'Save Case',
                class: 'btn-primary',
                action: function (property) {
                    property.value.draft = false;
                    _this.getAllErrors();
                    if (property.valid) {
                        _this.emitExternalEvent('save', property.exportValue());
                    }
                    else {
                        _this.emitExternalEvent('errors', property._errors);
                    }
                },
            },
            {
                id: 'saveDraft',
                label: 'Save Draft',
                class: 'btn-default',
                action: function (property) {
                    property.value.draft = true;
                    _this.emitExternalEvent('save', property.exportValue());
                },
            },
            {
                id: 'cancel',
                label: 'Cancel',
                class: 'btn-link',
                action: function (property) {
                    _this.emitExternalEvent('cancel', property.exportValue());
                },
            },
        ];
        this.emitExternalEvent('init', {
            loadLocations: this.externalLoadLocations.bind(this),
            getActions: this.externalGetActions.bind(this),
            setActions: this.externalSetActions.bind(this),
            getErrors: this.externalGetErrors.bind(this),
            getSchema: function () { return _this.schema; },
            setSchema: this.overrideSchema.bind(this),
        });
    }
    AppComponent.prototype.reloadSchema = function () {
        var schemaName = this.elementRef.nativeElement.getAttribute('schema');
        this.schemaModule = loadSchemaModule(schemaName);
    };
    AppComponent.prototype.overrideSchema = function (schema) {
        this.schemaModule.schema = schema;
    };
    Object.defineProperty(AppComponent.prototype, "schema", {
        get: function () {
            return this.schemaModule.schema;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "validators", {
        get: function () {
            return this.schemaModule.validators;
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.ngOnInit = function () {
        this.schemaModule.ngOnInit();
    };
    AppComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.schemaModule.hook(this.form);
        this.schemaModule.rebuild.subscribe(function () {
            _this.changeDetector.detectChanges();
        });
        this.emitExternalEvent('ready', {
            loadData: this.externalLoadData.bind(this),
            setMessage: this.externalSetMessage.bind(this),
            setToast: this.externalSetToast.bind(this),
            subscribeValueChanges: this.externalValueChanges.bind(this),
            subscribeErrorsChanges: this.externalErrorsChanges.bind(this),
            subscribeVisibilityChanges: this.externalVisibilityChanges.bind(this),
            setPropertyValue: this.externalSetPropertyValue.bind(this),
            getPropertyValue: this.externalGetPropertyValue.bind(this),
            getModel: this.externalGetModel.bind(this),
            getFormValue: this.externalGetFormValue.bind(this),
        });
        // Force another round of change detection because we injected external data.
        this.changeDetector.detectChanges();
    };
    AppComponent.prototype.externalLoadLocations = function (locations) {
        this.schemaModule.loadLocations(locations);
    };
    /**
     * @param keep Fields of steps 2 and 3 that were supplied on purpose and must survive
     *             the emptying a new sub-record otherwise gets - auto-fill reading a
     *             second operation off the same document. Empty for every other caller.
     */
    AppComponent.prototype.externalLoadData = function (data, options) {
        if (options === void 0) { options = {}; }
        this.model = data;
        this.checkParentId(options.keep || []);
        // this.checkProms();
    };
    AppComponent.prototype.checkParentId = function (keep) {
        if (keep === void 0) { keep = []; }
        if (this.model.parent_id) {
            // All the fields are contained within a single fieldset
            var properties = this.schema.fieldsets[0].fields;
            var step = 1;
            for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
                var propertyName = properties_1[_i];
                if (propertyName === 'step-2-heading') {
                    step = 2;
                    continue;
                }
                if (propertyName === 'step-3-heading') {
                    step = 3;
                    continue;
                }
                var property = this.schema.properties[propertyName];
                var widgetType = typeof property.widget === 'string' ? property.widget : property.widget.id;
                if (
                // Disable the entirety of step 1...
                step === 1 &&
                    // ... but allow procedure to be modified
                    propertyName !== 'main_procedure') {
                    this.disableProperty(property);
                }
                else if (!this.model.id) {
                    // Delete values in steps 2 & 3 for new sub-records...
                    if (
                    // ... except the ones the caller supplied for this sub-record
                    !keep.includes(propertyName) &&
                        (
                        // ... except for hidden fields
                        widgetType !== 'hidden' ||
                            // ... but still reset these hidden fields
                            propertyName === 'date_time' ||
                            propertyName === 'incomplete' ||
                            propertyName === 'draft')) {
                        delete this.model[propertyName];
                    }
                }
            }
        }
    };
    AppComponent.prototype.disableProperty = function (property) {
        property.readOnly = true;
        if (property.type === 'object') {
            Object.values(property.properties)
                .forEach(this.disableProperty.bind(this));
        }
    };
    AppComponent.prototype.checkProms = function () {
        if (!('proms' in this.schema.properties))
            return;
        var schema = this.schema;
        var model = this.model;
        if (model.proms && model.proms.id && model.proms.message) {
            schema.properties.proms.properties.message.widget.content = model.proms.message;
        }
        // Turn off PROMS for existing records
        if (this.model.id || this.model.parent_id) {
            schema.properties.proms.properties.follow_up_7.default = false;
        }
    };
    AppComponent.prototype.externalSetMessage = function (message) {
        this.schema.fieldsets[0].message = message;
    };
    AppComponent.prototype.externalGetActions = function () {
        return this.formActions;
    };
    AppComponent.prototype.externalSetActions = function (actions) {
        this.formActions = actions;
    };
    AppComponent.prototype.externalGetErrors = function () {
        return this.getAllErrors();
    };
    Object.defineProperty(AppComponent.prototype, "formActions", {
        get: function () {
            return this._formActions;
        },
        set: function (buttons) {
            this._formActions = buttons;
            function clearAction(button) {
                return __assign({}, button, { action: null });
            }
            function clearActions(button) {
                if (isSchemaButtonGroup(button)) {
                    return __assign({}, button, { buttons: button.buttons.map(clearActions) });
                }
                else {
                    return clearAction(button);
                }
            }
            // Clear the button actions before adding them to the schema.
            this.schema.buttons = buttons.map(clearActions);
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.externalSetToast = function (newToast) {
        var emptyToast = {
            content: '',
            classes: '',
        };
        Object.assign(this._toast, emptyToast, newToast);
        this.changeDetector.detectChanges();
    };
    AppComponent.prototype.externalValueChanges = function (path, func) {
        var property = this.form.rootProperty.searchProperty(path);
        if (property)
            property.valueChanges.debounceTime(1).subscribe(func);
    };
    AppComponent.prototype.externalErrorsChanges = function (path, func) {
        var property = this.form.rootProperty.searchProperty(path);
        if (property)
            property.errorsChanges.debounceTime(1).subscribe(func);
    };
    AppComponent.prototype.externalVisibilityChanges = function (path, func) {
        var property = this.form.rootProperty.searchProperty(path);
        if (property)
            property.visibilityChanges.debounceTime(1).subscribe(func);
    };
    AppComponent.prototype.emitExternalEvent = function (eventName, data) {
        this.elementRef.nativeElement.dispatchEvent(new CustomEvent(eventName, {
            bubbles: true,
            detail: data,
        }));
    };
    AppComponent.prototype.listenExternalEvent = function (eventName, callback) {
        this.elementRef.nativeElement.addEventListener(eventName, callback);
    };
    AppComponent.prototype.getAllErrors = function () {
        var _this = this;
        this.form.rootProperty.forEachChildRecursive(function (property) {
            _this.form.rootProperty.extendErrors(property._errors);
        });
    };
    AppComponent.prototype.setDraft = function (draft) {
        this.model.draft = draft;
    };
    Object.defineProperty(AppComponent.prototype, "actions", {
        get: function () {
            var _this = this;
            var actions = {};
            for (var _i = 0, _a = this.formActions; _i < _a.length; _i++) {
                var button = _a[_i];
                var buttons = isSchemaButtonGroup(button) ? button.buttons : [button];
                buttons.forEach(function (button) {
                    if (button.action)
                        actions[button.id] = button.action.bind(_this);
                });
            }
            return actions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "toast", {
        get: function () {
            return this._toast;
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.externalSetPropertyValue = function (attrName, attrValue) {
        this.model[attrName] = attrValue;
    };
    AppComponent.prototype.externalGetPropertyValue = function (attrName) {
        return this.model.hasOwnProperty(attrName) ? this.model[attrName] : undefined;
    };
    AppComponent.prototype.externalGetModel = function () {
        return __assign({}, this.model);
    };
    /**
     * The form's live values, including edits the user has not saved yet.
     *
     * getModel() cannot be used for this: [model] is a one-way binding, so this.model is
     * only ever written by externalLoadData() and holds the data as loaded rather than as
     * edited. The edits live on the root property, which is what the save action reads.
     */
    AppComponent.prototype.externalGetFormValue = function () {
        return this.form.rootProperty.exportValue();
    };
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/app.component.ts.pre-build-optimizer.js